import { render, staticRenderFns } from "./FlipCardInteractivityForm.vue?vue&type=template&id=47cc269c"
import script from "./FlipCardInteractivityForm.vue?vue&type=script&lang=js"
export * from "./FlipCardInteractivityForm.vue?vue&type=script&lang=js"
import style0 from "./FlipCardInteractivityForm.vue?vue&type=style&index=0&id=47cc269c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports